import { SeparatorProps } from './index';

const componentName = 'separator';

function Separator({ separatorLine, separatorSpaceAbove, separatorSpaceBelow }: SeparatorProps): JSX.Element {
    return (
        <div className={componentName}>
            <div
                className={`${componentName}__space-above`}
                style={{
                    height: separatorSpaceAbove.height,
                    background: separatorSpaceAbove.backgroundColor ? separatorSpaceAbove.backgroundColor : undefined,
                }}
            />
            <div
                className={`${componentName}__line`}
                style={{
                    height: separatorLine.height,
                    background: separatorLine.backgroundColor ? separatorLine.backgroundColor : undefined,
                }}
            />
            <div
                className={`${componentName}__space-below`}
                style={{
                    height: separatorSpaceBelow.height,
                    background: separatorSpaceBelow.backgroundColor ? separatorSpaceBelow.backgroundColor : undefined,
                }}
            />
        </div>
    );
}

export default Separator;
